import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { MatterPropertyType, PropertyType } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';

export interface TitleSyncPropertyTypeWarningModalData {
	isLegalDescriptionCondoUnit: boolean;
}

@UntilDestroy()
@Component({
	selector: 'app-title-sync-property-type-warning-modal',
	templateUrl: './title-sync-property-type-warning-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TitleSyncPropertyTypeWarningModalComponent implements OnInit {
	@Select(SelectedMatter.propertyType)
	propertyType$: Observable<MatterPropertyType>;

	public propertyType: MatterPropertyType = {};
	public propertyTypeHardCopy: MatterPropertyType = {};

	public ICON = ICON;
	public isLegalDescriptionCondoUnit: boolean;
	public propertyTypes = PropertyType;
	constructor(
		private dialogRef: MatDialogRef<TitleSyncPropertyTypeWarningModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: TitleSyncPropertyTypeWarningModalData,
	) {
		this.isLegalDescriptionCondoUnit = this.data.isLegalDescriptionCondoUnit;
	}

	ngOnInit(): void {
		this.propertyType$.pipe(untilDestroyed(this)).subscribe((propertyType) => {
			if (propertyType) {
				this.propertyType = cloneDeep(propertyType);
				this.propertyTypeHardCopy = cloneDeep(propertyType);
			} else {
				this.propertyType = {};
			}
		});

		this.dialogRef.updateSize('650px');
	}

	onPropertyChange(propertyType: MatterPropertyType) {
		this.propertyType = propertyType;
	}

	cancel() {
		this.dialogRef.close();
	}

	update() {
		this.dialogRef.close(this.propertyType);
	}
}
